import { Logo as AppLogo } from '../../../assets/icons';
import { Link } from 'react-router-dom';

export function Logo(props) {
	const title = 'FinPath';

	return (
		<Link to='/' {...props} title={title} aria-label={title}>
			<AppLogo aria-hidden='true' />
		</Link>
	);
}
